import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { wacToken } from "@/libraries/design/foundations";
import {
    StatsModuleProps,
    Stats
} from "@/libraries/design/patterns/stats/src/stats";

export const TeamStats = () => {
    const intl = useIntl();

    const statsProps: StatsModuleProps = {
        headerText: intl.formatMessage({
            id: "HomePageTemplateV2.teamStatsHeader",
            defaultMessage: "Teams across the globe run on Atlassian"
        }),
        bigStat: {
            stat: "300000",
            statText: intl.formatMessage({
                id: "HomePageTemplateV2.teamStatsCompaniesTxt",
                defaultMessage:
                    "companies power team collaboration with Atlassian"
            }),
            statColor: wacToken("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: wacToken("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "200",
                statText: intl.formatMessage({
                    id: "HomePageTemplateV2.teamStatsPeopleTxt",
                    defaultMessage:
                        "countries and territories have companies that use Atlassian"
                }),
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "+",
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            },
            {
                stat: "80",
                statText: intl.formatMessage({
                    id: "HomePageTemplateV2.teamStatsFortune500Txt",
                    defaultMessage:
                        "of Fortune 500 companies use Atlassian products"
                }),
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            }
        ]
    };

    return (
        <UFOSegment name="homepage-v2-stats">
            <section>
                <Stats {...statsProps} />
            </section>
        </UFOSegment>
    );
};

TeamStats.displayName = "TeamStats";
